import styles from "./CrawlCostEstimator.module.css";
import { Form, Row, Col, Button, Spinner } from "react-bootstrap";
import { useCallback, useEffect, useState } from "react";
import EllipseComponent from "../../components/EllipseComponent/EllipseComponent";
import { useLocation } from "react-router-dom";
import { getCrawlCostEstimator } from "../../api/portalApi";

const CrawlCostEstimator = (props) => {
    // Data State
    const [domain, setDomain] = useState("");
    const [frequency, setFrequency] = useState("w");
    const [numProducts, setNumProducts] = useState(1000);
    const [crawlCostData, setCrawlCostData] = useState({});

    // UI State
    const [loading, setLoading] = useState(false);
    const [refreshData, setRefreshData] = useState(true)

    const location = useLocation();

    const fetchData = useCallback( async() => {
        setLoading(true);
        try {
            const res = await getCrawlCostEstimator(domain, frequency, numProducts);
            setCrawlCostData(res?.data?.data || res?.data);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }

    }, [domain, frequency, numProducts]);

    useEffect(() => { 
        if (refreshData){
            fetchData();
            setRefreshData(false);
        }
    }, [refreshData, fetchData])

    let cceContent;
    if (loading){
        cceContent = (
            <div className={styles.ellipseArrangement}>
                <Spinner animation="border"/>
            </div>
        );
    } else {
        cceContent = (<div className={styles.ellipseArrangement}>
            <EllipseComponent labelText="Datacenter Estimate per month" ellipseText={crawlCostData?.datacenter_cost_per_month !== "" ? "$" + crawlCostData?.datacenter_cost_per_month?.toFixed(2) : "N/A"}/>
            <EllipseComponent labelText="Residential Estimate per month" ellipseText={crawlCostData?.residential_cost_per_month !== "" ? "$" + crawlCostData?.residential_cost_per_month?.toFixed(2) : "N/A"}/>
            <EllipseComponent labelText="Unlocker Estimate per month" ellipseText={crawlCostData?.unlocker_cost_per_month !== "" ? "$" + crawlCostData?.unlocker_cost_per_month?.toFixed(2) : "N/A"}/>
        </div>);
    }
    return (
        <div className={styles.cce}>
            {location?.pathname === "/control-panel/crawl-cost-estimator" ? <h4>Crawl Cost Estimator</h4> : <a href="/control-panel/crawl-cost-estimator"><h4>Crawl Cost Estimator</h4></a>}
            <Form>
                <Form.Group as={Row} className="mb-3">
                        <Form.Label column sm="1">
                            Domain:
                        </Form.Label>
                        <Col sm="10">
                            <Form.Control type="text" value={domain} onChange={(e) => setDomain(e.target.value)}/>
                        </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3">
                        <Form.Label column sm="1">
                            Frequency:
                        </Form.Label>
                        <Col>
                            <div className={styles.cceOptions}>
                                <Button id="d" variant={frequency === "d" ? "dark" : "outline-dark" } onClick={() => setFrequency("d")}>Daily</Button>
                                <Button id="w" variant={frequency === "w" ? "dark" : "outline-dark" } onClick={() => setFrequency("w")}>Weekly</Button>
                                <Button id="m" variant={frequency === "m" ? "dark" : "outline-dark" } onClick={() => setFrequency("m")}>Monthly</Button>
                            </div>
                        </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3">
                        <Form.Label column sm="1">
                            No. Products:
                        </Form.Label>
                        <Col sm="10">
                            <Form.Control type="number" value={numProducts} onChange={(e) => setNumProducts(e.target.value)}/>
                        </Col>
                </Form.Group>
                <Button onClick={() => setRefreshData(true)}>Refresh</Button>
               
            </Form>
            {cceContent}
        </div>
    )
};

export default CrawlCostEstimator;